<ub-heading i18n>Details</ub-heading>
<form *ngIf="formData$ | async; let formData; else loading" [formGroup]="formData.form" (ngSubmit)="onSubmit()">
  <app-form-fields [formData]="formData"></app-form-fields>
  <button mat-flat-button color="primary" type="submit" *ngIf="formData.controlCount > 0" [disabled]="formData.submitting || formData.invalid">{{
    formData.options.submitTitle ?? getDefaultSubmitButtonTitle() }}</button>
</form>
<ng-template #loading>
  <div i18n>Loading ...</div>
</ng-template>
